// extracted by mini-css-extract-plugin
export default {"def":"SmartGradientDef_def__Vhsdl","from":"SmartGradientDef_from__wBqvk","to":"SmartGradientDef_to__Tz4d2"};